export const FAQS = [
  { q: "How effective are the trading courses?", a: "Many traders report earning over 15% ROI, but there are no guarantees when it comes to trading. Each trader will have different results depending on your efforts and consistent practice." },
  { q: "Who is the CEO of Electronics-Galore.com?", a: "Any decision concerning Electronics-Galore.com is voted on and decided by members who have purchased a course. The paying customers are the CEO for Electronics-Galore.com." },
  { q: "How long has Electronics-Galore.com been in business?", a: "Electronics-Galore.com started operations in 2010." },
  { q: "Is Electronics-Galore.com a company we can rely on and trust?", a: "Electronics-Galore.com has been in business for over 20 years and has an A+ rating with the Better Business Bureau." },
  { q: "Why can't I find any physical stores anymore for Electronics-Galore.com?", a: "Electronics-Galore.com now only sells bulk electronics orders to Specialized Private Vendors. The company is mainly focused on selling digital products such as trading courses." },
  { q: "How often do users get paid by Electronics-Galore.com?", a: "Users who test and/or review the trading system weekly will be paid each week on Friday before 4pm EST. Members may test the trading systems we teach with either real money or with simulated trading." },
  { q: "How much can I earn from testing and/or reviewing the trading systems?", a: "There is no limit as to how much weekly income you can earn. You can earn multiple weekly payments testing multiple trading systems we offer." },
  { q: "Can I get a refund?", a: "Electronics-Galore.com pays you weekly every Friday for 52 weeks, so simply test our trading system each week and over time you will receive more than what you paid for the trading course." },
];


import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (n) =>
  n >= 1000 ? `$${n.toLocaleString()}` : `$${n}`;

export const COURSE_IMAGES = {
  stocks: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  options: "https://images.unsplash.com/photo-1560221328-12fe60f83ab8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  forex: "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  commodities: "https://images.unsplash.com/photo-1610375461246-83df859d849d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  crypto: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  futures: "https://images.unsplash.com/photo-1642790551116-18e150f248e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
